<template>
  <div>
    <div v-if="isEndOfPublication">
       <end-of-publication/>
    </div>
      <div v-else>
        <search-bar-sp
          v-if="isSearchBarReady"
          :preflist="preflist"
          :options="options"
          :update="update"
          :isSearchBody="isSearchBody"
          @input="isSearchBody = $event"
        />
        <search-loading v-if="!isReady" />

        <!-- TODO: パンクず記事のタイトル埋め込み -->
        <common-layout-template
          v-if="isReady && propData !== undefined"
          :isBread="true"
          :prop_name="propData.name"
          :pref_name="locationObject.pref.name"
          :bg_ground_white="true"
          :max_width="true"
          :no_padding="isDisplayNewPage"
        >
        <template v-slot:body>
          <kodate-contents v-if="isReady && propData !== undefined && !isDisplayNewPage"
            :propData="propData"
            :referrerCheck="referrerCheck"
          />
          <kodate-contents-new v-if="isReady && propData !== undefined && extraPropData !== undefined  &&  isDisplayNewPage"
            :propData="propData"
            :extraPropData="extraPropData"
            :referrerCheck="referrerCheck"
          />
        </template>
      </common-layout-template>
    </div>
  </div>
</template>

<script>
import IsMobileMixin from '@/plugins/isMobile';
import BehaviorLogMixin from '@/plugins/mixin-behavior-log';
import MixinAPI from '@/plugins/mixin-api';
import Meta from '@/plugins/mixin-meta';

import KodateContents from '@/components/detail/KodateContents';
import KodateContentsNew from '@/components/detail/KodateContentsNew';
import SearchBarPc from '@/components/search/kodate/pc/SearchBar';
import SearchBarSp from '@/components/search/kodate/sp/SearchBar';
import CommonLayoutTemplate from '@/components/templates/CommonLayoutTemplate';
import SearchLoading from '@/components/search/kodate/SearchLoading';
import EndOfPublication from '@/components/Maintenance/EndOfPublication';

const querystring = window.location.search;
const query = [...new URLSearchParams(querystring).entries()]
  .reduce((obj, e) => ({ ...obj, [e[0]]: e[1] }), {});
const canonical = location.href.match(/\/$/) === null ? `${location.href}/` : location.href;

export default {
  name: 'DetailKodate',
  components: {
    KodateContents,
    KodateContentsNew,
    SearchBarPc,
    SearchBarSp,
    CommonLayoutTemplate,
    SearchLoading,
    EndOfPublication,
  },
  mixins: [IsMobileMixin, MixinAPI, Meta, BehaviorLogMixin],
  data() {
    return {
      view: [],
      isReady: false,
      isSearchBody: false,
      isDisplayNewPage: false,
      options: {
        prefcode: '0',
        citycode: '0',
        ask: false,
        byBus: false,
        layout: [],
        priceLow: 0,
        priceHigh: 999999999,
        landAreaLow: 0,
        landAreaHigh: 99999,
        buildingAreaLow: 0,
        buildingAreaHigh: 99999,
        walkin: 999,
        fw: '',
        size: 30,
        order: 0,
        page: 1,
      },
      propData: {},
      extraPropData: {},
      preflist: [],
      locationObject: {
        pref: {},
        city: {},
      },
      isSearchBarReady: false,
      isEndOfPublication: false,
      referrerCheck: false,
    };
  },
  metaInfo() {
    return {
      link: [
        { rel: 'canonical', href: canonical },
      ],
    };
  },
  computed: {
    storedViewHistory() {
      return this.$store.getters['getViewHistory'];
    },
  },
  async created() {
    const q = this.$route.params.propertyid;

    this.propData = await this.getPropertyData(q);
    if (this.propData === false) {
      window.location.href = '/404/';
      return;
    }
    if (this.propData.data.media !== 'suumo' && this.propData.data.media !== 'ielove') {
      window.location.href = '/404/';
      return;
    }
    this.propData = this.propData.data;

    if (!this.propData.is_available || this.propData.priority < 50) {
      this.isEndOfPublication = true;
      document.title = '掲載が終了しました｜一戸建て・一軒家がミツカル 不動産情報サイト｜ケイアイスター不動産 ケイアイのミツカル';
      document.querySelector('meta[name="description"]').setAttribute('content', '＜この物件は掲載が終了しております。＞ミツカルはケイアイスター不動産が運営する新築・中古の一戸建て・一軒家がおトクに探せるポータルサイト。全国のグループ各社やFC加盟店で取り扱う豊富な物件情報を、エリアや大きな地図から検索できるのはもちろん、地域に密着したエリア情報や住宅お役立ち情報、さらに全国の小中学校の学区検索であなたが探す物件がきっとミツカル！');
      const meta = document.createElement('meta');
      meta.setAttribute('name', 'robots');
      meta.setAttribute('content', 'noindex');
      document.getElementsByTagName('head')[0].appendChild(meta);
      return;
    }

    if (query.testid) {
      this.propData.external_ki_site_id = query.testid;
    }

    if (this.propData.external_ki_site_id !== '' && this.propData.external_ki_site_id) {
      this.extraPropData = await this.getExtraPropertyData(this.propData.external_ki_site_id);
      if (this.extraPropData.data !== '') {
        this.isDisplayNewPage = true;
        this.extraPropData = this.extraPropData.data;
      }
    }

    // Location info
    const list = await this.getCityList(1, this.propData.location.pref_code, this.propData.kind);
    const values = list.filter(n => n.city_code.toString() === this.propData.location.city_code.toString())[0];
    values.town = {
      data: {
        town_id: '',
        town_code: '',
        town_name: '',
      },
    };
    if (this.propData.location.town_code) {
      values.town = await this.identifyTownCode(this.propData.location.town_code);
    }
    this.locationObject = {
      type: 1,
      area: {
        id: values.area_id,
        code: values.area_code,
        name: values.area_name,
      },
      pref: {
        id: values.pref_id,
        code: values.pref_code,
        name: values.pref_name,
      },
      city: {
        id: values.city_id,
        code: values.city_code,
        name: values.city_name,
      },
      town: {
        id: values.town.data.town_id,
        code: values.town.data.town_code,
        name: values.town.data.town_name,
      },
      station: {
        id: null,
        code: null,
        name: null,
      },
    };
    // this.metaSetForDetail(values.pref_name, values.city_name);

    // store property data
    this.$store.commit('setProp', this.propData);
    this.$store.commit('setLocation', this.locationObject);

    // search bar

    this.preflist = await this.getPrefectureList(1, this.propData.kind);
    this.options.prefcode = this.propData.location.pref_code;
    this.isSearchBarReady = true;

    // store viewHistory
    this.view = this.storedViewHistory;
    if (this.view === null) this.view = [];
    this.setSiteAccessLogs({
      id: this.propData.id,
      pageName: this.propData.name,
      count: 1,
    });

    const referrerCheck = document.referrer.match(location.origin);
    if (!referrerCheck) {
      this.referrerCheck = true;
    }

    this.isReady = true;
  },
  mounted() {
  },
  methods: {
    getHostType() {
      switch (location.host) {
        default:
          return null;
        case 'yeah.ki-group.jp':
          return 'prod';
        case 'test-yeah.ki-group.jp':
          return 'dev';
        case 'localhost:8080':
          return 'local';
      }
    },
    update(page = 1) {
      let url = location.origin;
      url += `/kodate/area/${this.options.prefcode}/`;
      if (this.options.citycode !== 0 && this.options.citycode !== '0') url += `${this.options.citycode}/`;

      // page
      url += `?page=${page}`;
      // size
      url += `&size=${this.options.size}`;
      // order
      url += `&order=${this.options.order}`;

      // layout
      if (this.options.layout.length > 0) url += `&layout=${this.options.layout.join()}`;
      // 価格未設定を含む
      if (this.options.ask) url += '&ask=true';
      // バス時間を含む
      if (this.options.byBus) url += '&byBus=true';
      // fw
      if (this.options.fw) url += `&fw=${this.options.fw}`;
      // price
      url += `&priceLow=${this.options.priceLow}`;
      url += `&priceHigh=${this.options.priceHigh}`;
      // landarea
      url += `&landAreaLow=${this.options.landAreaLow}`;
      url += `&landAreaHigh=${this.options.landAreaHigh}`;
      // buildingarea
      url += `&buildingAreaLow=${this.options.buildingAreaLow}`;
      url += `&buildingAreaHigh=${this.options.buildingAreaHigh}`;

      // walkin
      url += `&walkin=${this.options.walkin}`;

      location.href = url;
    },
  },
};
</script>

<!-- Add 'scoped' attribute to limit CSS to this component only -->
<style scoped lang="scss">
@charset "UTF-8";

</style>
